if (!customElements.get('card-color-thumbnails')) {
  customElements.define(
    'card-color-thumbnails',
    class CardColorThumbnails extends HTMLElement {
      connectedCallback() {
        this.addEventListener('click', this.handleThumbnailClick);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.handleThumbnailClick);
      }

      handleThumbnailClick = (event) => {
        const button = event.target.closest('[data-card-color-thumbnail]');
        if (!button || !this.contains(button)) return;

        event.preventDefault();
        event.stopPropagation();

        const card = this.closest('.product-card-wrapper');
        const image = card?.querySelector('[data-card-primary-image]');
        if (!card || !image) return;

        image.src = button.dataset.imageSrc;
        image.srcset = button.dataset.imageSrcset;
        image.alt = button.dataset.imageAlt;

        card.classList.add('card-color-is-previewing');
        card.querySelectorAll('a.full-unstyled-link').forEach((link) => {
          link.href = button.dataset.variantUrl;
        });

        this.querySelectorAll('[data-card-color-thumbnail]').forEach((thumbnail) => {
          const isActive = thumbnail === button;
          thumbnail.classList.toggle('is-active', isActive);
          thumbnail.setAttribute('aria-pressed', isActive ? 'true' : 'false');
        });
      };
    }
  );
}
